import cn from 'classnames'
import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Checkbox } from 'core-components/library/checkbox'

import { HintComponent } from '../../../HintComponent'

import styles from './NoPlanCheckbox.module.scss'

interface IProps {
  isNoPlanDisabled: boolean
  isNoPlan: boolean
  onToggle: () => void
  withPlanCount: number
  variant?: 'default' | 'contractual'
}

export const NoPlanCheckbox = ({
  isNoPlanDisabled,
  isNoPlan,
  onToggle,
  withPlanCount,
  variant = 'default',
}: IProps) => {
  const containerClass = cn(styles.infoContainer, styles.infoContainerWithCheckbox)
  const switcherClass = cn(styles.noPlanSwitcher, {
    [styles.noPlanContractual]: variant === 'contractual',
  })
  const textClass = cn(styles.noPlanSwitcherText, { [styles.disabledItem]: isNoPlanDisabled })

  const showWarning = useMemo(
    () => !isNoPlan && withPlanCount <= 1 && variant !== 'contractual',
    [isNoPlan, variant, withPlanCount]
  )

  return (
    <div className={containerClass}>
      <div className={switcherClass}>
        <Checkbox padding disabled={isNoPlanDisabled} checked={isNoPlan} onChange={onToggle} />
        <div className={textClass}>
          <Translation span text="jbp-planning-no-plan-switcher" />
        </div>
      </div>
      {showWarning && <HintComponent text="jbp-planning-no-plan-warning" />}
    </div>
  )
}

export default NoPlanCheckbox
